module.exports = __webpack_public_path__ + "img/gfuzum.50e96e01.png";